import React, { Component } from "react";
import { View, TextInput, Image, TouchableOpacity } from 'react-native';

import { CircleButton } from "./Button";
import { CaptionNormalDark, SubheaderNormalDark, ErrorMessage, BodyNormalDark } from "./TextStyles";
import styles from "../../shared/styles";

import hide_ic from '../assets/icon/hide_ic.png';
import show_ic from '../assets/icon/show_ic.png';
import editIcon from '../assets/icon/edit_ic.png';
import { global, colors } from "../../shared/const";

export const InputFiled = ({ placeholder, lable, errorMessage, value, style, onChange, rightComponent, ...others }) => (
    <View>
        <CaptionNormalDark title={lable} />
        <View style={[styles.inputField, style]}>
            <TextInput
                style={[styles.input, rightComponent && {paddingRight: 40}]}
                placeholder={placeholder}
                value={value}
                onChangeText={onChange}
                {...others}
            />
            {rightComponent && 
                (<View style={{ position: "absolute", right: 15}}>
                    {rightComponent}
                </View>)
            }
        </View>
        <ErrorMessage title={errorMessage} />
    </View>
)


export class EditInputFiled extends Component {

    state = {
        editMode: false
    }

    render() {
        const { value, lable } = this.props
        return (
            <View>
                {!this.state.editMode ? <CaptionNormalDark title={lable} /> : null}
                {
                    this.state.editMode ?
                        <InputFiled
                            {...this.props}
                        />
                        :
                        <View style={{ flexDirection: 'row', marginHorizontal: 2, justifyContent: 'space-between', alignItems: 'center', height: 50 }}>
                            <SubheaderNormalDark title={value} />
                            <CircleButton
                                component={(<Image
                                    source={editIcon} resizeMode="contain"
                                    style={{ height: 20, width: 20 }} />)}
                                onPress={() => this.setState({ editMode: true })}
                            />
                        </View>
                }

            </View>
        )
    }
}

export class EditPasswordFiled extends Component {

    state = { status: false }

    render() {
        const { value, lable } = this.props;
        let password = '';
        for (let i = 0; i < value.length; i++) password = password + '*'

        return (
            <View style={{ marginTop: 10 }}>
                <CaptionNormalDark title={lable} />
                <View style={{ flexDirection: 'row', marginHorizontal: 2, justifyContent: 'space-between', alignItems: 'center', height: 50 }}>
                    <SubheaderNormalDark title={this.state.status ? value : password} />
                    <CircleButton
                        component={(
                            <Image source={this.state.status ? hide_ic : show_ic} resizeMode="contain" style={{ height: 20, width: 20, marginRight: 8 }} />
                        )}
                        onPress={this.onChangeStatus}
                    />
                </View>
            </View>
        )
    }

    onChangeStatus = () => {
        return this.setState({ status: !this.state.status });
    }
}

export class SignupPasswordField extends Component {

    state = {
        status: global.isNative,
        progress: null,
        showPass: false,
    }
    componentWillReceiveProps() {
        if (!global.isNative) {
            const { status } = this.props;
            this.setState({ status: status });
        }
    }
    onPassword = (password) => {
        this.props.onChange(password, (progress) => this.setState({ progress }));
    }

    render() {
        const { lable, value, placeholder, passwordError } = this.props;
        const { status, progress } = this.state;
        return (
            <View style={{ marginHorizontal: 20 }}>
                <InputFiled
                    lable={lable}
                    secureTextEntry={status}
                    autoComplete="off"
                    onChange={this.onPassword}
                    style={styles.borderGrey}
                    value={value}
                    placeholder={placeholder}
                    rightComponent={!this.state.showPass ?
                        <TouchableOpacity activeOpacity={0.8} onPress={() => this.setState({ status: !status, showPass: true })}><Image source={show_ic} resizeMode="contain" style={{ height: 18, width: 18 }} /></TouchableOpacity>
                        :
                        <TouchableOpacity activeOpacity={0.8} onPress={() => this.setState({ status: !status, showPass: false })}><Image source={hide_ic} resizeMode="contain" style={{ height: 18, width: 18 }} /></TouchableOpacity>
                    }
                />
                <View style={{ justifyContent: "space-between", marginTop: global.isNative ? -10 : 10, flexDirection: "row" }}>

                    <View
                        style={[{ height: 8, width: '18%', borderTopLeftRadius: 6, borderBottomLeftRadius: 6 }, progress >= 1 ? { backgroundColor: colors.darkgreen } : styles.bglightGray]}
                    />

                    <View
                        style={[{ height: 8, width: '18%' }, progress >= 2 ? { backgroundColor: colors.darkgreen } : styles.bglightGray]}
                    />

                    <View
                        style={[{ height: 8, width: '18%' }, progress >= 3 ? { backgroundColor: colors.darkgreen } : styles.bglightGray]}
                    />

                    <View
                        style={[{ height: 8, width: '18%' }, progress >= 4 ? { backgroundColor: colors.darkgreen } : styles.bglightGray]}
                    />

                    <View
                        style={[{ height: 8, width: '18%', borderTopRightRadius: 6, borderBottomRightRadius: 6 }, progress >= 5 ? { backgroundColor: colors.darkgreen } : styles.bglightGray]}
                    />

                </View>
                <BodyNormalDark title={passwordError} />
            </View>
        )
    }
}

export const InputWithButton = ({ placeholder, value, style, onChange, rightComponent, onSubmitEditing }) => (
    <View style={[styles.inputField, style]}>
        <TextInput
            autoCorrect={true}
            style={styles.input}
            keyboardType={'default'}
            placeholder={placeholder}
            value={value}
            onChangeText={onChange}
            onSubmitEditing={onSubmitEditing ? onSubmitEditing : () => null}
        />
        <View style={{ alignItems: "flex-end" }}>
            {rightComponent}
        </View>
    </View>
)